export const ArrowFunctionExpression = 'ArrowFunctionExpression'
export const AwaitExpression = 'AwaitExpression'
export const BlockStatement = 'BlockStatement'
export const CallExpression = 'CallExpression'
export const ExportAllDeclaration = 'ExportAllDeclaration'
export const ExportNamedDeclaration = 'ExportNamedDeclaration'
export const ExpressionStatement = 'ExpressionStatement'
export const File = 'File'
export const Import = 'Import'
export const ImportDeclaration = 'ImportDeclaration'
export const Program = 'Program'
export const StringLiteral = 'StringLiteral'
export const VariableDeclaration = 'VariableDeclaration'
export const VariableDeclarator = 'VariableDeclarator'
